import RequestService from './request';

class SteamProfileService {
    get(steamid64: string): string {
        return RequestService.baseURL() + `/steam-profile/${steamid64}`;
    }
}

export default new SteamProfileService();
